package music.limasoul.client.shared.instrument.di

import music.limasoul.client.shared.instrument.data.repository.InstrumentRepositoryImpl
import music.limasoul.client.shared.instrument.domain.repository.InstrumentRepository
import org.koin.dsl.module

val instrumentModule = module {

    single<InstrumentRepository> {
        InstrumentRepositoryImpl(
            httpClient = get()
        )
    }
}